import React, {useState, useEffect} from 'react';
import Typography from '@material-ui/core/Typography';
import {sortBy} from 'lodash-es';
import Seletor from '../App/Seletor';
import Funcionarios from '../App/Funcionarios'


function Page_Funcionarios (props) {
  const { empresas } = props.data;
  const [ empresa, setEmpresa ] = useState(null);
  const [ opt, setOpt ] = useState([]);
  useEffect(() => {
    setOpt(sortBy(empresas,'Apelido').map(e => {
      let label = e.Cidade ? ` - ${e.Cidade} ` : " "
      label = e.Apelido + label + `(${e.Codigo})`
      return { value: e.Codigo, label, sublabel: e.RazaoSocial }
    }))
  }, [empresas])

  return (
    <>
    <div style={{ display: "flex", marginBottom:"15px", alignItems: 'center', justifyContent: 'center' }}>
      <div style={{ flex: '0 0 300px' }}>
        <Typography variant="h4" >Funcionários</Typography>
      </div>
      <div style={{ flex: '0 0 600px' }}>
        <Seletor
          fullWidth
          label={"Empresa"}
          onChange={setEmpresa}
          value={empresa}
          placeholder="Selecione a empresa"
          suggestions={opt}
          />
      </div>
    </div>
    { empresa && 
      <Funcionarios empresa={empresa} />
    }
    </>
  )
}

export default Page_Funcionarios;
